import {LocalisationInfo} from '../../class/api/LocalisationInfo';

export class ExLocalisationInfo extends LocalisationInfo {
    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }
        if (options == null) {
            this.typeLocalisations = 0;
            this.cancerPrimitifs = [];
        }
    }
}
